import messages from './messages';
import { FeatureTile } from './types';

export const tiles: FeatureTile[] = [
	{
		src: '/_n/images/plans/upsell-waves.webp',
		alt: 'waves',
		copy: messages.dailyCalmCopy,
	},
	{
		src: '/_n/images/plans/upsell-canyon.webp',
		alt: 'canyon',
		copy: messages.meditationsCopy,
	},
	{
		src: '/_n/images/plans/upsell-sunset.webp',
		alt: 'sunset',
		copy: messages.musicCopy,
	},
	{
		src: '/_n/images/plans/upsell-milky-way.webp',
		alt: 'milky way',
		copy: messages.sleepStoriesCopy,
	},
	{
		src: '/_n/images/plans/upsell-woman-beach.webp',
		alt: 'woman on beach',
		copy: messages.matserclassCopy,
	},
	{
		src: '/_n/images/plans/upsell-body.webp',
		alt: 'yoga studio',
		copy: messages.bodyCopy,
	},
];
